<template>
  <div>
    <b-container v-if="isLoading" class="text-center d-flex justify-content-center">
      <b-form>
        <br><br><br>
        <h5>loading</h5>
        <br>
          <b-spinner style="color: rgb(109,122,82) !important"
          variant="warning"
        ></b-spinner>
      </b-form>
    </b-container>
    <div v-else>
      <div>
        <br>
        <b-row style="height:40vh;margin:0" class="welcome-picture">
          <b-col cols="1" sm="2">
          </b-col>
          <b-col cols="10" sm="8" style="height:100%">
            <div class="welcome-overlay">
              <h1 class="main-title"><b><span style="color: rgb(195,147,130)">WYNE</span></b>CELLAR</h1>
              <p class="main-subtitle">FORGOT PASSWORD</p>
            </div> 
          </b-col>
        </b-row>
        <br>
        <br>
        <br> 
        <b-row v-if="!mailSent">
          <b-col cols="1" sm="2">
          </b-col>
          <b-col cols="10" sm="8" class="text-left">
            <p class="w-title">You forgot your password? </p>
            <br>
            <p class="w-text">No problem, fill in your email below.</p>
            <p class="w-text">If you are registered, you will receive a link to reset your password.</p>
            <br>
            <b-form>
              <b-form-group>
                <label class="w-label w-required" for="input-username">email</label>
                <b-form-input
                  id="input-username"
                  class = "w-input"
                  style = "background-color:white !important"
                  v-model="form.email"
                  v-bind:class="{'form-control':true, 'is-invalid' : !this.emailValid}"
                  aria-describedby="input-live-help input-live-feedback"
                  type="email"
                  required
                ></b-form-input>
                <b-form-invalid-feedback id="input-live-feedback">
                    {{emailFeedback}}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-form>
          </b-col>
        </b-row>  
        <b-row v-if="!mailSent">
          <b-col cols="1" sm="2">
          </b-col>
          <b-col cols="10" sm="8" class="text-right"> 
            <b-button v-on:click="gotoSend()" class="w-button-green">send</b-button>
          </b-col>
        </b-row>
        <b-row v-else>
          <b-col cols="1" sm="2">
          </b-col>
          <b-col cols="10" sm="8" class="text-left">
            <p class="w-title">An email with a link has been sent to {{form.email}}</p>
            <br>
            <p class="w-text">PS: Please also check your spam.</p>
            <br>
          </b-col>
        </b-row>  
      </div>  
    </div>
  </div>
</template>

<script>
  import UserID_from_Email from '../UserID_from_Email.js';
  import ResetPassword from '../ResetPassword.js';

  export default {
    name: 'ForgotPassword',
    data() {
      return {
        debug: true,

        form: {
          email:'',
        },

        emailValid: true,
        emailFeedback: '',

        mailSent: false,

        isLoading : true,
      }
    }, 
    async mounted() {
      this.isLoading = false
    },
    methods: {
      validate() {
        // validate email 
        let hasAt = false;
        let hasDot = false;
        for (let i=0;i < this.form.email.length;i++) {
            if (this.form.email[i] === '@') {
                hasAt = true;
            }
            if (this.form.email[i] === '.') {
                hasDot = true;
            }
        }
        this.emailValid = hasAt && hasDot
        if ( ! this.emailValid) {
            this.emailFeedback='This is an invalid email format';
            this.passwordValid = true;
        }

        this.isValid = this.emailValid;
      },  
      async gotoSend() {
        this.validate();
        if (this.isValid) {
          let challenge = {"email": this.form.email}
          await UserID_from_Email.getToken(challenge)
          .then(response => {
            if (this.debug) console.log("Forgot Password in gotoSend: response = ", response);
            if (response !=0) {
              this.user_id = response;
            } else {
              this.user_id = 0;
            }
          })
          .catch(error=>{
            if (this.debug) console.log("Forgot Password in gotoSend: catch UserID_from_Email error = ", error);
          })

          if (this.user_id !=0) {
            await ResetPassword.sendEmail(this.user_id)
            .then(response=>{
              if (this.debug) console.log("Forgot Password in gotoSend: ",this.user_id," has been succesfully registered ", response)  
              this.mailSent = true;
            })
            .catch(error => {
              if (this.debug) console.log('RForgot Password in gotoSend: ', error)
            })
          }
        }
      }
    }
  }
</script>

<style>
@import url("../assets/styles/wynestyle.css");
</style>

<style scoped>
.welcome-picture {
    width:100%;
    height:auto;
    
    background-image: url("../assets/img/header.jpg");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;

    position:relative;
}
.welcome-overlay {
  position: relative;
  top: 10vh;
}

.over {
    position: relative;
    width:90%;
    top: -50px;
    left: 45%;
    z-index: 3;
    color: black;
    padding: 3% 15% 10% 10%;
    background-color:white;
    border-radius: 1%;
      -webkit-transform: translate3d(-50%,0,0);
         -moz-transform: translate3d(-50%,0,0);
          -ms-transform: translate3d(-50%,0,0);
           -o-transform: translate3d(-50%,0,0);
              transform: translate3d(-50%,0,0);
}

.main-text {
  font-family: 'Segoe UI';
  font-size: 16px;
  color: rgb(112,112,112);
}

.w-picture{
  height: 200px;
  width: auto;
}
.w-detail {

}
.w-title {
  font-size: 18px;
  margin: 10px 0 0 0;
}

.w-subtitle {
  font-size:14px;
  margin:0.5vm;
}

.w-text {
  margin:0;
  font-size: 12px;
}

.w-smalltext {
  padding-top : 10px;
  font-size: 10px;
}
</style> 